export default "__VITE_ASSET__CqPydIZM__"